
const viewRouter = [
  {
    path: '/birthday',
    name: 'birthday',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '生日评分',
    },
    component: () => import('@/pages/live/live'),
  },
  {
    path: '/cost',
    name: 'cost',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '手机号估值',
    },
    component: () => import('@/pages/phone/phone'),
  },
  {
    path: '/phone',
    name: 'phone',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '手机号估值',
    },
    component: () => import('@/pages/phone/phoneCost'),
  },
  {
    path: '/phone/two',
    name: 'phoneTwo',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '手机号估值',
    },
    component: () => import('@/pages/phone/phoneTwo'),
  },
  {
    path: '/cost/one',
    name: 'phoneCostOne',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '手机号估值',
    },
    component: () => import('@/pages/phoneCost/costOne'),
  },
  {
    path: '/cost/car',
    name: 'phoneCostCar',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '手机号估值',
    },
    component: () => import('@/pages/phoneCost/phoneCar'),
  },
  {
    path: '/score',
    name: 'score',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '手机号评分',
    },
    component: () => import('@/pages/phoneScore/phoneScore'),
  },
  {
    path: '/sleep',
    name: 'sleep',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '睡觉楼层',
    },
    component: () => import('@/pages/sleep/sleep'),
  },
  {
    path: '/riddles',
    name: 'riddles',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '脑筋急转弯',
    },
    component: () => import('@/pages/riddle/riddles'),
  },
  {
    path: '/riddle',
    name: 'riddle',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '脑筋急转弯',
    },
    component: () => import('@/pages/riddle/riddle'),
  },
  {
    path: '/driving',
    name: 'driving',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/driving'),
  },
  {
    path: '/driving/one',
    name: 'driving_one',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingOne'),
  },
  {
    path: '/driving/two',
    name: 'driving_two',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingTwo'),
  },
  {
    path: '/driving/three',
    name: 'driving_three',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingThree'),
  },
  {
    path: '/driving/four',
    name: 'driving_four',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingFour'),
  },
  {
    path: '/driving/five',
    name: 'driving_five',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingFive'),
  },
  {
    path: '/driving/six',
    name: 'driving_six',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingSix'),
  },
  {
    path: '/driving/seven',
    name: 'driving_seven',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '1天通关科目一',
    },
    component: () => import('@/pages/driving/drivingSeven'),
  },
  {
    path: '/dream/one',
    name: 'dreamOne',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '周公解梦',
    },
    component: () => import('@/pages/dream/dreamOne'),
  },
  {
    path: '/dream/two',
    name: 'dreamTwo',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '周公解梦',
    },
    component: () => import('@/pages/dream/dreamTwo'),
  },
  {
    path: '/challenge/one',
    name: 'challengeOne',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '脑筋急转弯',
    },
    component: () => import('@/pages/challenge/challengeOne'),
  },
  {
    path: '/challenge/two',
    name: 'challengeTwo',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '脑筋急转弯',
    },
    component: () => import('@/pages/challenge/challengeTwo'),
  },
  {
    path: '/guess',
    name: 'guess',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '几号先装满',
    },
    component: () => import('@/pages/cup/guess'),
  },
  {
    path: '/cup/one',
    name: 'cupOne',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '几号先装满',
    },
    component: () => import('@/pages/cup/cupOne'),
  },
  {
    path: '/cup/two',
    name: 'cupTwo',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '几号先装满',
    },
    component: () => import('@/pages/cup/cupTwo'),
  },
  {
    path: '/cup/three',
    name: 'cupThree',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '几号先装满',
    },
    component: () => import('@/pages/cup/cupThree'),
  },
  {
    path: '/cup/four',
    name: 'cupFour',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '几号先装满',
    },
    component: () => import('@/pages/cup/cupFour'),
  },
  {
    path: '/ball',
    name: 'ball',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '几号球最先到',
    },
    component: () => import('@/pages/ball/ball'),
  },
  {
    path: '/custom',
    name: 'custom',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/customView/customView'),
  },
  {
    path: '/listen/wechat',
    name: 'wechat',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/customView/wechat'),
  },
  {
    path: '/record',
    name: 'record',
    meta: {
      tab: "record",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/customView/record'),
  },
  {
    path: '/ai',
    name: 'ai',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/customView/aiView'),
  },
  {
    path: '/poem',
    name: 'poem',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/customView/poem'),
  },
  {
    path: '/book',
    name: 'book',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/book/book'),
  },
  {
    path: '/pengle',
    name: 'pengle',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    // component: () => import('@/pages/book/pengle'),
    component: () => import('@/pages/book/pengleNew'),
  },
  {
    path: '/story/one',
    name: 'storyOne',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '美女和野兽',
    },
    component: () => import('@/pages/story/story'),
  },
  {
    path: '/story/two',
    name: 'storyTwo',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '美女和野兽',
    },
    component: () => import('@/pages/story/story'),
  },
  {
    path: '/story/three',
    name: 'storyThree',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '美女和野兽',
    },
    component: () => import('@/pages/story/story'),
  },
  {
    path: '/story/four',
    name: 'storyFour',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '美女和野兽',
    },
    component: () => import('@/pages/story/story'),
  },
  {
    path: '/goods/drinks',
    name: 'drinks',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/goods/drinks'),
  },
  {
    path: '/goods/nut',
    name: 'nut',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '',
    },
    component: () => import('@/pages/goods/nut'),
  },
  {
    path: '/listen/one',
    name: 'listen_one',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '听书直播间',
    },
    component: () => import('@/pages/book/bookOne'),
  },
  {
    path: '/listen/two',
    name: 'listen_two',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '听书直播间',
    },
    component: () => import('@/pages/book/bookTwo'),
  },
  {
    path: '/listen/three',
    name: 'listen_three',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '听书直播间',
    },
    component: () => import('@/pages/book/bookThree'),
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      tab: "live",
      type: 'livePage',
      title: '远程音频循环播放器',
    },
    component: () => import('@/pages/test/test'),
  },
  {
    path: '/remove/one',
    name: '/remove/one',
    meta: {
      tab: "/remove/one",
      type: 'livePage',
      title: '去除绿幕',
    },
    component: () => import('@/pages/removeColor/greenScreen'),
  },
  {
    path: '/remove/two',
    name: '/remove/two',
    meta: {
      tab: "/remove/two",
      type: 'livePage',
      title: '去除绿幕',
    },
    component: () => import('@/pages/removeColor/webgl'),
  },
  {
    path: '/webgl',
    name: '/webgl',
    meta: {
      tab: "/remove/three",
      type: 'livePage',
      title: '去除绿幕',
    },
    component: () => import('@/pages/removeColor/webgl2'),
  },


]
export default viewRouter
